import { FleetVehicleOfferSaleEditFormValues, FleetVehicleOfferSaleItemEditFormValues, FleetVehicleOfferSaleSearchFormValues, FleetVehicleOfferRentEditFormValues, FleetVehicleOfferRentItemEditFormValues, FleetVehicleOfferRentSearchFormValues } from "./types";

export const OfferSaleStatusId = {
  Draft: "draft",
  Created: "created",
  Sent: "sent",
  Accepted: "accepted",
  Paid: "paid",
  Cancelled: "cancelled",
} as const;

export type OfferSaleStatusIdType = typeof OfferSaleStatusId[keyof typeof OfferSaleStatusId];

export const initialFleetVehicleOfferSaleEditForm: FleetVehicleOfferSaleEditFormValues =
{
  offerNumber: null,
  offerSaleStatusId: null,
  vehicleId: null,
  contactClientId: null,
  contactConsumerId: null,
  offerDate: new Date(),
  dueDate: null,
  durationDays: null,
  note: null,
  items: []
};

export const initialFleetVehicleOfferSaleItemEditForm: FleetVehicleOfferSaleItemEditFormValues =
{
  id: crypto.randomUUID(),
  code: null,
  name: null,
  taxRate: 25,
  quantity: 1,
  priceWithoutTax: null,
  priceWithTax: null,
  discountAmount: null,
  discountTypeId: "PERCENTAGE",
  total: null,
  note: null,
  billingItemTypeId: null,
  kpdCode: null,
  unitOfMeasureId: null,

};

export const initialFleetVehicleOfferSaleSearchForm: FleetVehicleOfferSaleSearchFormValues =
{
  search: null,
  offerSaleStatusId: null,
  offerDateFrom: null,
  offerDateTo: null,
  dueDateFrom: null,
  dueDateTo: null,
  totalMin: null,
  totalMax: null,
  contactClientId: null,
};

export const OfferRentStatusId = {
  Draft: "draft",
  Created: "created",
  Sent: "sent",
  Accepted: "accepted",
  Paid: "paid",
  Cancelled: "cancelled",
} as const;

export type OfferRentStatusIdType = typeof OfferRentStatusId[keyof typeof OfferRentStatusId];

export const initialFleetVehicleOfferRentEditForm: FleetVehicleOfferRentEditFormValues =
{
  offerNumber: null,
  offerRentStatusId: null,
  vehicleId: null,
  contactClientId: null,
  contactConsumerId: null,
  offerDate: new Date(),
  dueDate: null,
  durationDays: null,
  rentStartDate: null,
  rentEndDate: null,
  rentDurationMonths: null,
  monthlyPrice: null,
  note: null,
  items: []
};

export const initialFleetVehicleOfferRentItemEditForm: FleetVehicleOfferRentItemEditFormValues =
{
  id: crypto.randomUUID(),
  code: null,
  name: null,
  taxRate: 25,
  quantity: 1,
  priceWithoutTax: null,
  priceWithTax: null,
  discountAmount: null,
  discountTypeId: "PERCENTAGE",
  total: null,
  note: null,
  billingItemTypeId: null,
  kpdCode: null,
  unitOfMeasureId: null,
};

export const initialFleetVehicleOfferRentSearchForm: FleetVehicleOfferRentSearchFormValues =
{
  search: null,
  offerRentStatusId: null,
  offerDateFrom: null,
  offerDateTo: null,
  dueDateFrom: null,
  dueDateTo: null,
  totalMin: null,
  totalMax: null,
  contactClientId: null,
};

